import { Icon } from '@/js/components/icon'

export default function ProductItem({ item, components, onRemove }) {
    return (
        <a href={item.url} className="aa-ItemLink">
            <div className="aa-ItemContent">
                <div className={`aa-ItemIcon ${item.theme}`}>
                    <Icon name={item.icon_url ?? item.icon} />
                </div>
                <div className="aa-ItemContentBody">
                    <div className="aa-ItemContentTitle">
                        <components.Highlight hit={item} attribute="label" />
                        {item.shortDescription && (
                            <small className="text-muted ms-2">
                                <components.Highlight hit={item} attribute="shortDescription" />
                            </small>
                        )}
                    </div>
                    <div className="aa-ItemContentDescription">{item.description}</div>
                </div>
            </div>
            <div className="aa-ItemActions">
                {onRemove && (
                    <button
                        type="button"
                        className="aa-ItemActionButton aa-DesktopOnly"
                        title="Remove this search"
                        aria-label="Remove this search"
                        onClick={(event) => {
                            event.preventDefault()
                            event.stopPropagation()
                            onRemove(item.id)
                        }}
                    >
                        <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                            <path d="M18 7v13c0 0.276-0.111 0.525-0.293 0.707s-0.431 0.293-0.707 0.293h-10c-0.276 0-0.525-0.111-0.707-0.293s-0.293-0.431-0.293-0.707v-13zM17 5v-1c0-0.828-0.337-1.58-0.879-2.121s-1.293-0.879-2.121-0.879h-4c-0.828 0-1.58 0.337-2.121 0.879s-0.879 1.293-0.879 2.121v1h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1h1v13c0 0.828 0.337 1.58 0.879 2.121s1.293 0.879 2.121 0.879h10c0.828 0 1.58-0.337 2.121-0.879s0.879-1.293 0.879-2.121v-13h1c0.552 0 1-0.448 1-1s-0.448-1-1-1zM9 5v-1c0-0.276 0.111-0.525 0.293-0.707s0.431-0.293 0.707-0.293h4c0.276 0 0.525 0.111 0.707 0.293s0.293 0.431 0.293 0.707v1zM9 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1zM13 11v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1z" />
                        </svg>
                    </button>
                )}
                <button
                    className="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                    type="button"
                    title="Select"
                    aria-label="Select"
                >
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
                        <path d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z" />
                    </svg>
                </button>
            </div>
        </a>
    )
}
